/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'more': {
    width: 16,
    height: 16,
    viewBox: '0 0 60 60',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M30 13.04v33.92M46.96 30H13.04"/><path pid="1" class="cls-2" d="M49.5 52.13a29.42 29.42 0 1 1 8-11.53"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/more.js